<script>
  import { onMount } from "svelte";
  import { subscribe, remove } from "../../toast";

  let messages = $state([]);

  onMount(() => subscribe((m) => { messages = m; }));

  const icons = {
    error: "fas fa-times-circle",
    info: "fas fa-info-circle",
    success: "fas fa-check-circle",
    warning: "fas fa-exclamation-triangle",
  };
</script>

<div class="mjn-toast-container">
  {#each messages as m (m.id)}
    <div
      class="mjn-toast mjn-toast-{m.type}"
      onclick={() => remove(m.id)}
      role="alert"
    >
      <i class={icons[m.type]} aria-hidden="true"></i> {m.message}
    </div>
  {/each}
</div>

<style>
  .mjn-toast-container {
    position: fixed;
    top: 12px;
    right: 12px;
    z-index: 2000;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .mjn-toast {
    min-width: 240px;
    max-width: 360px;
    padding: 10px 14px;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  }
  .mjn-toast-error {
    background: #bd362f;
  }
  .mjn-toast-info {
    background: #2f96b4;
  }
  .mjn-toast-success {
    background: #51a351;
  }
  .mjn-toast-warning {
    background: #f89406;
  }
</style>
